export class Payment {
  id: string;
  type: string;
  status: string;
  amount: number;
  displayType?: string;
  isElectronicPayment: boolean;
  progressBillingEnabled: boolean;
  confirmationNumber: number;
  description: string;
  transactionId: string;
  createdDate: string;
  paidOnDate: string;
  tokenId: string;
  invoiceId: string;
  currentlyAcceptsPayment: boolean;
  groupId: string;
  billingAccountNumber: string;
  dueDate: string;
  invoiceFileName: string;
  invoiceDate: string;
}
